import { render, staticRenderFns } from "./BulkProductUpload.vue?vue&type=template&id=21a65bdf"
import script from "./BulkProductUpload.vue?vue&type=script&lang=js"
export * from "./BulkProductUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports